import instObj from '@/backend/axios-instances'

const resource = "/cutsheets"
const instance = instObj.baseInstance

export default {
  post(data) {
    return instance.post(`${resource}/steps`, data);
  },
  put(stepId, data) {
    return instance.put(`${resource}/step/${stepId}`, data);
  },
  get(parameters) {
    return instance.get(`${resource}/steps`, { params: parameters });
  },
  delete(stepId) {
    return instance.delete(`${resource}/step/${stepId}`);
  }
}
